export enum FrontendDateTimeFormat {
  DATE_RFC3339 = "YYYY-MM-DDTHH:mm:ssZ",
}
